export var formatNumber = function(val) {
    return new Intl.NumberFormat().format(val);
};
